// @ts-nocheck

import {
  Box,
  CloseButton,
  HStack,
  Image,
  Progress,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";
import Dropzone from "react-dropzone";
import { IUploadStore } from "../stores";

// {name: "segun", size: "24KB", url: "url.com"}

// const defaultStore = UploadStore.create(
//   {},
//   {
//     cloudinaryApiHandler: (files, progressCallback) => {
//       let promises = files.map((o) =>
//         uploadToCloudinary(o, progressCallback).then((b) => {
//           let { original_filename, bytes, secure_url } = b.data;
//           let newFile = {
//             name: original_filename,
//             size: `${Math.round(bytes / 1000)}KB`,
//             url: secure_url,
//           };
//           return newFile;
//         })
//       );
//       return Promise.all(promises);
//     },
//   }
// );

const Upload: React.FC<{
  accept?: string;
  maxSize?: number;
  minSize?: number;
  beforeUpload?: any;
  isDisabled?: boolean;
  allowMultiple?: boolean;
  name?: string;
  children?: any;
  store?: IUploadStore;
  displayProgress?: boolean;
  [key: string]: any;
}> = observer(
  ({
    accept = "image/*",
    maxSize,
    minSize,
    beforeUpload,
    isDisabled,
    allowMultiple,
    name,
    children,
    afterDrop,
    displayProgress = true,
    defaultValue = [],
    useDefaultValues = false,
    onDelete,
    store,
    ...rest
  }) => {
    let _files: any[] = useDefaultValues ? defaultValue : store.rawFiles;
    return (
      <Fragment>
        {(_files || []).length ? (
          <FileAttachment
            files={_files}
            onDeleteFile={onDelete || store.onDeleteFile}
          />
        ) : (
          !store.isUploading && (
            <Dropzone
              {...{ accept, minSize, maxSize }}
              multiple={allowMultiple}
              onDrop={async (files) => {
                try {
                  await store.onDrop(files, store.progressCallback);
                  if (afterDrop) {
                    afterDrop();
                  }
                } catch (error) {
                  console.log(error);
                }
              }}
              onDragEnter={() => console.log("Drag enter")}
              onDropRejected={() => console.log("Drop Rejected")}
              onDropAccepted={() => console.log("Drop accepted")}
              onDragOver={() => console.log("Drag over")}
            >
              {({ getRootProps, getInputProps }) => {
                return (
                  <Box as="span" {...rest} {...getRootProps()}>
                    <input {...getInputProps()} />
                    {children}
                  </Box>
                );
              }}
            </Dropzone>
          )
        )}

        {displayProgress && store.isUploading && (
          <Box>
            {/* <Spinner /> */}
            <Text>Uploading...</Text>
            <Progress height="4px" value={Number(store.percent)} />
          </Box>
        )}
      </Fragment>
    );
  },
);

export default Upload;

export const FileAttachment = ({ files, onDeleteFile }) => {
  if (files.length > 0) {
    return (
      <Stack>
        {files.map((file, index) => (
          <Box
            key={file.name}
            px={3}
            py={1}
            rounded="md"
            borderWidth="2xs"
            borderColor="neutral.500"
          >
            <HStack justifyContent="space-between">
              <Text isTruncated width="60%">
                {file.name}
              </Text>
              <Text width="15%">{file.size}</Text>
              <CloseButton onClick={() => onDeleteFile(index)} />
            </HStack>
          </Box>
        ))}
      </Stack>
    );
  }

  return null;
};
